import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { AppointmentBillableStatus } from '../Enums/AppointmentBillableStatus.enum';
import { EMode } from '../Enums/EMode.enum';

export class AppointmentDetails<T extends EMode = EMode.entity> {
  /** Alias: t_Code */
  t_Code?: number;
  /** Alias: billableStatus */
  billableStatus?: AppointmentBillableStatus;

  __typename?: string;
}

const fields: FieldDefinitions<AppointmentDetails> = {
  t_Code: {
    alias: 't_Code',
  },
  billableStatus: {
    alias: 'billableStatus',
  },
  __typename: {
    alias: '__typename',
  },
};

export const appointmentDetailsEntityDefinition: EntitiyDefinition<AppointmentDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'AppointmentDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
